import ScreenLoader from "../../../../elements/CustomScreeenLoader/ScreenLoader";
import { useEffect, useState } from "react";
import styles from "./LetterOfIntent.module.scss";
import cn from "classnames";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  TableCell,
  Typography,
} from "@mui/material";
import DataTable from "../../../../elements/CustomDataTable/DataTable";
import { liveBid_prouduct_List } from "../../../../elements/CustomDataTable/PortalColumnData";
import _sendAPIRequest from "../../../../helpers/api";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { dateTimeFormatter } from "../../../../helpers/formatter";
const Bidresult = ({ bidDetails }) => {
  const [bidletter, setBidletter] = useState({});
  const [bidresult, setBidresult] = useState([]);
  const [handleResultMessage, setHandleResultMessage] = useState(null);
  const [screenLoader, setScreenLoader] = useState(true);
  const fetchLOIforSupplier = async () => {
    try {
      const response = await _sendAPIRequest(
        "GET",
        PortalApiUrls.LIVE_BID_LETTER_OF_INTENT_FOR_SUPPLIER +
          `${bidDetails?.id}`,
        "",
        true,
      );
      if (response.status === 200) {
        setBidletter(response?.data);
        setScreenLoader(false);
      }
    } catch (error) {
      console.log("error");
      setScreenLoader(false);
    }
  };

  const fetchBidResult = async () => {
    try {
      const response = await _sendAPIRequest(
        "GET",
        PortalApiUrls.LIVE_BID_RESULT_FOR_SUPPLIER + `${bidDetails?.id}`,
        "",
        true,
      );
      if (response.status === 200) {
        setBidresult(response?.data);
        setScreenLoader(false);
      }
    } catch (error) {
      console.log(error);
      setScreenLoader(false);
    }
  };
  useEffect(() => {
    fetchLOIforSupplier();
    fetchBidResult();
  }, []);

  if (screenLoader) {
    return <ScreenLoader />;
  }

  const handleButtonAction = (cell) => {
    const { live_bid_product, is_awarded } = cell?.row?.original;
    const result =
      live_bid_product?.award_status === "cancelled"
        ? "Cancelled"
        : is_awarded
          ? "Awarded"
          : "Not Awarded";
    const color =
      result === "Cancelled" || result === "Not Awarded" ? "red" : "green";

    if (cell?.column?.id === "result") {
      return (
        <TableCell
          {...cell.getCellProps()}
          align="left"
          padding="none"
          style={{ paddingLeft: "12px" }}
        >
          <Button
            onClick={() => setHandleResultMessage(result)}
            sx={{
              color: "#fff",
              backgroundColor: color,
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "8px",
              padding: "6px 16px",
              minWidth: "120px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
              "&:hover": {
                backgroundColor: color,
                opacity: 0.9,
              },
            }}
          >
            {result}
          </Button>
        </TableCell>
      );
    } else {
      return (
        <TableCell {...cell.getCellProps()} align={cell.column.align}>
          {" "}
          {cell.render("Cell")}{" "}
        </TableCell>
      );
    }
  };

  return (
    <>
      <Box
        classname={cn("row", styles["result-box"])}
        sx={{ marginTop: "2rem", marginLeft: "8px" }}
      >
        {!handleResultMessage ? (
          <Box className={styles["result-message-box"]}>
            <Typography variant="h5" className={styles["result-message-title"]}>
              Product Results Declared
            </Typography>

            <Typography className={styles["result-message-greeting"]}>
              Dear Supplier,
            </Typography>

            <Typography className={styles["result-message-content"]}>
              We would like to inform you that the results for the products
              included in this bid have now been officially declared after the
              completion of the bidding process.
              <br />
              <br />
              To check the outcome, simply hover over the{" "}
              <strong>Result</strong> column in the table below.
              <br />
              <br />
              Thank you for your participation and cooperation throughout the
              bidding process.
            </Typography>
          </Box>
        ) : handleResultMessage === "Awarded" ? (
          <>
            <Box className={styles["award-message"]}>
              <Typography
                variant="h6"
                className={styles["award-message__title"]}
              >
                Congratulations! Product Awarded
              </Typography>

              <Typography className={styles["award-message__content"]}>
                Dear <strong>{bidletter?.supplier?.name}</strong>,
                <br />
                <br />
                We are pleased to inform you that your company has been selected
                as the awarded supplier for the product(s) in this bid after the
                successful completion of the bidding process.
                <br />
                <br />
                This confirms that the contract for the respective product(s)
                has been awarded to your company. Please review the details
                below and proceed with the next steps as required.
                <br />
                <br />
                We look forward to working with you and appreciate your
                cooperation in ensuring timely and quality delivery.
              </Typography>
            </Box>
            <br />
            <Accordion defaultExpanded>
              <AccordionSummary>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography>{bidletter?.buyer?.name}</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                {/* Wrap the content you want to print with the componentRef */}
                <div>
                  <div className={styles["loi-content"]}>
                    <div className={styles["bid-Letter"]}>
                      <Typography
                        variant="h6"
                        className={styles["bid-letter-contnet"]}
                      >
                        LETTER OF INTENT FOR BID AWARD
                      </Typography>
                    </div>
                    <br />
                    <Typography>
                      Date: {dateTimeFormatter(bidletter?.created_at)}
                    </Typography>
                    <Typography>
                      LOI Number: <strong>{bidletter?.formatted_number}</strong>
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Buyer Information
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          <th>Company Email</th>
                          <th>Contact</th>
                          <th>GST No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bidletter?.buyer?.name}</td>
                          <td>{bidletter?.buyer?.business_email}</td>
                          <td>{bidletter?.buyer?.business_mobile}</td>
                          <td>{bidletter?.buyer?.gstin}</td>
                        </tr>
                      </tbody>
                    </table>

                    {bidletter?.buyer?.address?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{
                            marginTop: "20px",
                            mb: 2,
                            fontSize: "large",
                            fontWeight: "bold",
                          }}
                        >
                          Buyer Addresses
                        </Typography>
                        <table className={styles["loi-table"]}>
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>City</th>
                              <th>Country</th>
                              <th>Pincode</th>
                              <th>State</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bidletter?.buyer?.address?.map((address) => {
                              return (
                                <tr>
                                  <td>{address?.address}</td>
                                  <td>{address?.city}</td>
                                  <td>{address?.country}</td>
                                  <td>{address?.pincode}</td>
                                  <td>{address?.state}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </>
                    )}

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Supplier Information
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Company Name</th>
                          <th>Company Email</th>
                          <th>Contact</th>
                          <th>GST No.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{bidletter?.supplier?.name}</td>
                          <td>{bidletter?.supplier?.business_email}</td>
                          <td>{bidletter?.supplier?.business_mobile}</td>
                          <td>{bidletter?.supplier?.gstin}</td>
                        </tr>
                      </tbody>
                    </table>

                    {bidletter?.supplier?.address?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{
                            marginTop: "20px",
                            mb: 2,
                            fontSize: "large",
                            fontWeight: "bold",
                          }}
                        >
                          Supplier Addresses
                        </Typography>

                        <table className={styles["loi-table"]}>
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>City</th>
                              <th>Country</th>
                              <th>Pincode</th>
                              <th>State</th>
                            </tr>
                          </thead>
                          <tbody>
                            {bidletter?.supplier?.address?.map((address) => {
                              return (
                                <tr>
                                  <td>{address?.address}</td>
                                  <td>{address?.city}</td>
                                  <td>{address?.country}</td>
                                  <td>{address?.pincode}</td>
                                  <td>{address?.state}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </>
                    )}

                    <Typography>
                      Dear <strong>{bidletter?.supplier?.name}</strong>, <br />
                      We are pleased to inform you that your company has been
                      selected as the preferred supplier for the following
                      products, following the conclusion of the live bidding
                      process.
                    </Typography>

                    <Typography
                      variant="h6"
                      sx={{ marginTop: "20px", mb: 2, fontWeight: "bold" }}
                    >
                      Products
                    </Typography>
                    <table className={styles["loi-table"]}>
                      <thead>
                        <tr>
                          <th>Product Name</th>
                          <th>Quantity</th>
                          <th>Reserved Price</th>
                          <th>Bid Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bidletter?.bid_pricing?.map((bidProduct) => (
                          <tr>
                            <td>{bidProduct.product?.title}</td>
                            <td>{bidProduct.product?.quantity}</td>
                            <td>₹ {bidProduct.product?.reserved_price}</td>
                            <td>₹ {bidProduct?.amount}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <Typography variant="h6">
                      <strong>Intent Statement:</strong>
                    </Typography>
                    <Typography>
                      This is just a Letter of Intent and is not legally
                      binding. All the key details of the intent will be clearly
                      outlined in this document, and you will also receive an
                      official copy. For the final contract, the buyer will
                      provide the necessary content to proceed.
                    </Typography>
                    <br />
                    <Typography variant="h6">
                      <strong>Next Steps</strong>
                    </Typography>
                    <Typography>
                      We request you to review the attached contract and provide
                      your confirmation by the deadline. Once confirmed, the
                      formal contract will be finalized and executed.
                    </Typography>

                    <Typography>
                      For any modifications or queries, please contact at{" "}
                      {bidletter?.buyer?.business_email} or
                      {bidletter?.buyer?.business_mobile}.
                    </Typography>
                    {/* New sections added */}
                    <Typography variant="h6" sx={{ marginTop: "20px" }}>
                      <strong>Delivery Term </strong>
                    </Typography>
                    <Typography>
                      {bidletter?.bid?.delivery_terms.replace(/<p>|<\/p>/g, "")}
                    </Typography>

                    <Typography variant="h6" sx={{ marginTop: "20px" }}>
                      <strong>Payment Term</strong>
                    </Typography>
                    <Typography>
                      {bidletter?.bid?.payment_terms.replace(/<p>|<\/p>/g, "")}
                    </Typography>

                    {/* Other sections remain unchanged */}
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </>
        ) : handleResultMessage === "Cancelled" ? (
          <>
            <Box className={styles["result-cancelled"]}>
              <Typography
                variant="h6"
                className={styles["result-cancelled__title"]}
              >
                Product Cancelled
              </Typography>

              <Typography className={styles["result-cancelled__content"]}>
                Dear Supplier,
                <br />
                <br />
                Please note that this product has been{" "}
                <strong>cancelled by the buyer</strong>. As a result, the
                bidding process for this product has been discontinued.
                <br />
                <br />
                No results will be declared for this product. You may refer to
                the remaining products in the list to check their respective
                results.
              </Typography>
            </Box>
          </>
        ) : handleResultMessage === "Not Awarded" ? (
          <>
            <Box className={styles["result-not-awarded"]}>
              <Typography
                variant="h6"
                className={styles["result-not-awarded__title"]}
              >
                Product Not Awarded
              </Typography>

              <Typography className={styles["result-not-awarded__content"]}>
                Dear Supplier,
                <br />
                <br />
                The bidding process for this product has been completed. After
                the final evaluation, this product has been awarded to another
                supplier.
                <br />
                <br />
                No further action is required from your side at this moment. We
                encourage you to participate in upcoming bids for future
                opportunities.
              </Typography>
            </Box>
          </>
        ) : null}
      </Box>
      <br />
      {bidresult.length > 0 && (
        <DataTable
          propsColumn={liveBid_prouduct_List}
          propsData={bidresult || []}
          action={handleButtonAction}
        />
      )}
    </>
  );
};
export default Bidresult;
